import { useEffect, useState } from 'react';
import styled from 'styled-components';
import SectionTitle from '../components/SectionTitle';
import ReservationForm from '../components/ReservationForm';
import { getSettings } from '../services/settingsService';

const Section = styled.section`
  max-width: 1200px;
  margin: 0 auto;
  padding: 3rem 1.5rem;
`;

const Hint = styled.p`
  margin-bottom: 1.5rem;
`;

function ReservationPage() {
  const [settings, setSettings] = useState(null);

  useEffect(() => {
    const loadData = async () => {
      setSettings(await getSettings());
    };

    loadData();
  }, []);

  return (
    <Section>
      <SectionTitle>Reservierung</SectionTitle>
      <Hint>{settings?.reservationHint}</Hint>
      <ReservationForm />
    </Section>
  );
}

export default ReservationPage;